import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { PaginatedResults } from '@app/interfaces/paginated-results';
import { Observable } from 'rxjs';
import { Invoice } from '../interfaces/invoice';
import { InvoiceFile } from '../interfaces/invoice-file';

@Injectable({
  providedIn: 'root',
})
export class InvoicesService {
  constructor(private apiService: ApiService) {}

  getInvoiceFile(invoiceId: number): Observable<InvoiceFile> {
    return this.apiService.get<InvoiceFile>('invoice/' + invoiceId.toString());
  }

  getInvoices(page: number = 1): Observable<PaginatedResults<Invoice>> {
    const data: any = {};
    if (page > 1) {
      data.page = page;
    }
    return this.apiService.getPaginatedResults<Invoice>('invoices', data);
  }
}
